export default __webpack_public_path__ + "static/media/black02.47d05137.jpg";